/**
 * Whether this site may use the microphone without asking. The Quest leaves VR to show a
 * permission prompt and does not come back, so nothing may ask for the microphone while
 * a VR session runs (2026-10-06, headset): the portal asks first, in the page.
 */
export type MicPermission = 'granted' | 'denied' | 'prompt' | 'unknown';

export async function micPermission(): Promise<MicPermission> {
  try {
    const status = await navigator.permissions?.query({ name: 'microphone' as PermissionName });
    return status?.state ?? 'unknown';
  } catch {
    // Browsers that cannot query the microphone (older Firefox) say nothing either way.
    return 'unknown';
  }
}

/** True when opening the microphone could show a prompt. */
export async function micMayPrompt(): Promise<boolean> {
  const state = await micPermission();
  return state === 'prompt' || state === 'unknown';
}
